
module.exports = [
  'M0 6 L16 16 L32 6 z M0 9 L0 26 L32 26 L32 9 L16 19 z'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/mail.js
 ** module id = 218
 ** module chunks = 0
 **/